import { Component } from "@angular/core";
import { MatDialogRef } from '@angular/material/dialog';
import { ParagraphUtil } from '../../shared/utils/paragraph.util';

@Component({
    selector: 'household-confirmation-modal',
    templateUrl: './household-confirmation-modal.component.html',
    styleUrls: ['./household-confirmation-modal.component.css']
})
export class HouseholdConfirmationdModal {

    constructor(public dialogRef: MatDialogRef<HouseholdConfirmationdModal>, public paragraphUtil: ParagraphUtil){
     }

     public onConfirm(){
        this.dialogRef.close(true);
    }
    
    public onCancel(){
        this.dialogRef.close(false);
    }
    
}